import type { Component } from "vue";
import LinkAndPlus from "~/components/icons/links/LinkAndPlus.vue";
import ClipboardAndPlusIcon from "~/components/icons/ClipboardAndPlusIcon.vue";
import PaperAndPlus from "~/components/icons/PaperAndPlus.vue";
import PencilIcon from "~/components/icons/PencilIcon.vue";

export type ToolboxButton = {
  mode: "schema" | "note" | "link_chain" | "underline";
  sizes: string;
  icon: Component;
  title: string;
  tooltip: string;
};

export function useToolboxButtons() {
  const { t } = useI18n();
  const showcase = useExamShowcase();

  const buttonModes = showcase
    ? (["link_chain", "underline"] as const)
    : (["schema", "note", "link_chain", "underline"] as const);
  const iconMap = {
    schema: ClipboardAndPlusIcon,
    note: PaperAndPlus,
    link_chain: LinkAndPlus,
    underline: PencilIcon,
  } as const;

  const sizeMap = {
    schema: "w-5 h-6",
    note: "w-5 h-5",
    link_chain: "w-5 h-5",
    underline: "w-5 h-5",
  } as const;

  return computed(() =>
    buttonModes.map(
      (mode) =>
        ({
          mode,
          title: t(`legal_text.textEditor.buttons.${mode}`),
          tooltip: t(`legal_text.textEditor.tooltips.${mode}`),
          icon: iconMap[mode],
          sizes: sizeMap[mode],
        }) satisfies ToolboxButton
    )
  );
}
